import {Component} from '@angular/core';

@Component({
  selector: 'cm-card',
  template: `
    <div>
      <ng-content select="cm-card-header"></ng-content>
      <ng-content select="cm-card-content"></ng-content>
      <ng-content select="cm-card-footer"></ng-content>
    </div>
  `,
  host: {
    'class': 'cm-card'
  },
})
export class CmCardComponent {
}

@Component({
  selector: 'cm-card-content',
  template: `
    <ng-content></ng-content>`,
  host: {'class': 'cm-card-content'}
})
export class CmCardContentComponent {
}

@Component({
  selector: 'cm-card-footer',
  template: `
    <ng-content></ng-content>`,
  host: {'class': 'cm-card-footer'}
})
export class CmCardFooterComponent {
}

@Component({
  selector: 'cm-card-title',
  template: `
    <ng-content></ng-content>`,
  host: {'class': 'cm-widget-title d-flex'}
})
export class CmCardTitleComponent {
}
@Component({
  selector: 'cm-card-header',
  template: `
    <ng-content></ng-content>`,
  host: {'class': 'cm-card-header'}
})
export class CmCardHeaderComponent {
}
